var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChevronLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 13,
    viewBox: "0 0 9 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.91797 7.21484C8.16406 6.96875 8.16406 6.55859 7.91797 6.3125L2.61328 0.980469C2.33984 0.734375 1.92969 0.734375 1.68359 0.980469L1.05469 1.60938C0.808594 1.85547 0.808594 2.26562 1.05469 2.53906L5.26562 6.75L1.05469 10.9883C0.808594 11.2617 0.808594 11.6719 1.05469 11.918L1.68359 12.5469C1.92969 12.793 2.33984 12.793 2.61328 12.5469L7.91797 7.21484Z",
    fill: "#416FF4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronLeft);
export default __webpack_public_path__ + "static/media/chevron-left.3b191c7d.svg";
export { ForwardRef as ReactComponent };